import { Component, OnInit, Input } from '@angular/core';
import { PrintService } from '../_services/print.service';
import { ResponsiveService } from '../_services/responsive.service';
@Component({
	selector: 'options-menu',
	templateUrl: './options-menu.component.html',
})
export class OptionsMenu implements OnInit {
	@Input() element = '';
	@Input() title = '';
	@Input() svg = 1;

	constructor(public print: PrintService, public rsp: ResponsiveService) {}

	ngOnInit(): void {}
}
